import { createTheme } from '@mui/material/styles';

import customColors from './colors'; // Import your custom colors

const theme = createTheme({
  palette: {
    primary: {
      main: customColors.primaryOrange,
    },
    secondary: {
      main: customColors.goldenYellow,
    },
    background: {
      default: customColors.pageBackground,
      paper: customColors.cardBackground,
    },
    text: {
      primary: customColors.textDark,
      secondary: customColors.textSecondary,
    },
    error: {
      main: '#FF4500',
    },
    success: {
      main: customColors.success,
    },
  },
  typography: {
    fontWeightBold: 500,
    fontWeightMedium: 500,
    fontWeightRegular: 400,
    h1: { fontWeight: 500 },
    h2: { fontWeight: 500 },
    h3: { fontWeight: 500 },
    h4: { fontWeight: 500 },
    h5: { fontWeight: 500 },
    h6: { fontWeight: 500 },
  },
});

export default theme;
